export default __webpack_public_path__ + "static/media/icono-empresas-blanco.dd632765.svg";